export class Perfil {
    idPerfil: number | undefined;
    //nombrePerfil : string | undefined;
    nomPerfil : string | undefined;
    descripcionPerfil: string | undefined;


    idPuesto     : number | undefined;
    nombrePuesto : string | undefined;
    descripcion  : string | undefined;
}
